import Link from 'next/link'

import { Button } from '@/shared/ui'

import NoSearchResult from '../../asset/no-search-result.svg'

export const NonVisibleRoomPage = () => {
  return (
    <div className="flex h-[calc(100vh-72px)] flex-col items-center bg-gray-50 pt-30">
      <NoSearchResult className="mb-6 block" />
      <h2 className="typo-headline2 mb-4 font-bold text-black">
        이 방은 삭제되었거나 비공개로 전환되었습니다
      </h2>
      <p className="typo-body1 mb-10 text-center font-normal text-gray-900">
        이미 계약하신 경우,
        <br />
        계약 상세 화면에서 방 세부 정보를 확인하실 수 있습니다.
      </p>
      <Button
        asChild
        variant="solid"
        color="primary"
        size="large"
        className="w-60"
      >
        <Link href="/">홈으로 이동</Link>
      </Button>
    </div>
  )
}
